import { FC, memo, useCallback } from 'react'
import { Definition, DefinitionLabel, DefinitionValue, Divider, OptionTemplate } from '@cargomart/ui'
import IconYarcheFull from 'assets/yarche-full.svg?react'
import { MODAL_IDS, ModalItem, ModalSimple, useModal } from 'components'
import { getFormattedPhoneWithPhoneExt, getFullNameFromFio } from 'helpers/string'
import { OrderItemContact, TerminalItem } from 'schema'

import { ModalTerminal } from '../ModalTerminal'

interface OrderDetailRoutePointProps {
  contact: OrderItemContact
  mode: 'departurePoint' | 'destinationPoint'
  terminal: TerminalItem
  className?: string
}

const OrderDetailRoutePoint: FC<OrderDetailRoutePointProps> = (props) => {
  const { className, contact, terminal, mode } = props
  const terminalModalId =
    mode === 'departurePoint' ? MODAL_IDS.YarcheDepartureTerminal : MODAL_IDS.YarcheDestionationTerminal
  const { closeModal, openModal } = useModal()

  const handleShow = useCallback(() => {
    openModal(terminalModalId)
  }, [openModal, terminalModalId])

  const handleClose = useCallback(() => {
    closeModal(terminalModalId)
  }, [closeModal, terminalModalId])

  return (
    <>
      <div className={className}>
        <div className="mb-4 text-title-lg">{mode === 'departurePoint' ? 'Место отправления' : 'Место выдачи'}</div>
        {terminal && (
          <OptionTemplate
            isNoHover
            className="!px-0 !pt-0"
            postfix={<IconYarcheFull size="xl" />}
            description={
              <>
                {terminal.address}
                <a className="link mt-2 block cursor-pointer text-body-md" onClick={handleShow}>
                  Показать подробно на карте
                </a>
              </>
            }
            title={
              <>
                <div className="text-title-sm">Магазин «Ярче»</div>
                {terminal.name}
              </>
            }
          />
        )}

        <Divider className="my-1" />

        <div className="grid grid-cols-[auto_1fr] gap-x-4 lg:grid-cols-[40%_1fr]">
          <Definition isInline labelClassName="!text-on-surface" valueClassName="col-span-1 ml-auto lg:ml-0">
            <DefinitionLabel>{mode === 'departurePoint' ? 'Отправитель' : 'Получатель'}</DefinitionLabel>
            <DefinitionValue className="break-all">
              {getFullNameFromFio({
                firstname: contact.firstname,
                lastname: contact.lastname,
                secondname: contact.secondname
              })}
            </DefinitionValue>
            <DefinitionLabel>Телефон</DefinitionLabel>
            <DefinitionValue>
              {getFormattedPhoneWithPhoneExt({
                phoneExt: contact.phoneExt,
                phoneNumber: contact.phone
              })}
            </DefinitionValue>
          </Definition>
        </div>
      </div>

      <ModalItem id={terminalModalId}>
        <ModalSimple id={terminalModalId} onClose={handleClose} title={terminal?.name || ''}>
          {terminal && <ModalTerminal terminal={terminal} />}
        </ModalSimple>
      </ModalItem>
    </>
  )
}

export default memo(OrderDetailRoutePoint)
